<template>
  <fieldset class="mb-8">
    <legend
      v-if="showTitle"
      class="fieldset-legend"
      v-text="form.attributes.title"
    />
    <div>
      <section :class="showOutline ? 'field-list field-list--outline': 'field-list'">
        <div
          v-for="field in fields"
          :key="`field-${field.id}`"
          class="w-full"
        >
          <Component
            :is="field.attributes.input_type"
            :field="field"
            :errors="errors.get(field.attributes.slug)"
            :initial-state="buildInitialStateForField(field)"
            :form-location="location"
            :union-slug="unionSlug"
            :flat-picker-date-format="flatPickerDateFormat"
            :is-disabled="isFieldVisibleOnlyToMember(field)"
            @inputChanged="updateSubmission"
            @uploadHasCompleted="$emit('uploadHasCompleted')"
            @filesHaveBeenAdded="$emit('filesHaveBeenAdded')"
          />
        </div>
      </section>
    </div>
  </fieldset>
</template>

<script type="text/babel">
import FileField from './inputs/FileField'
import DateField from './inputs/DateField'
import TimeField from './inputs/TimeField'
import InputField from './inputs/InputField'
import MonthField from './inputs/MonthField'
import RadioField from './inputs/RadioField'
import SelectField from './inputs/SelectField'
import CheckboxField from './inputs/CheckboxField'
import TextAreaField from './inputs/TextAreaField'
import DateTimeField from './inputs/DatetimeField'
import TelephoneField from './inputs/TelephoneField'
import Form from 'Base/Resources/assets/js/plugins/Form'
import MultiSelectField from './inputs/MultiSelectField'

export default {
  name: 'FormBuilderFieldSet',
  components: {
    'form-file': FileField,
    'form-image': FileField,
    'form-time': TimeField,
    'form-text': InputField,
    'form-url': InputField,
    'form-date': DateField,
    'form-month': MonthField,
    'form-email': InputField,
    'form-radio': RadioField,
    'form-number': InputField,
    'form-select': SelectField,
    'form-textarea': TextAreaField,
    'form-checkbox': CheckboxField,
    'form-telephone': TelephoneField,
    'form-datetime-local': DateTimeField,
    'form-multi-select': MultiSelectField,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    submission: {
      type: Object,
      required: false,
      default: () => new Form,
    },
    showOutline: {
      type: Boolean,
      required: false,
      default: false,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    hideNonMemberEditableFields: {
      type: Boolean,
      required: false,
      default: true,
    },
    unionSlug: {
      type: String,
      required: true,
    },
    flatPickerDateFormat: {
      type: String,
      required: true,
    },
  },
  computed: {
    fields() {
      return this.hideNonMemberEditableFields
        ? this.form.fields.data.filter(field => field.attributes.access_level === 'member-editable')
        : this.form.fields.data
    },
    errors() {
      return this.submission.errors
    },
    location() {
      return window.location.pathname.split('/').pop()
    },
  },
  methods: {
    updateSubmission(event) {
      this.submission[event.field] = event.value

      this.$emit('submissionUpdated', {
        'form_id': this.form.uuid,
        'submission': this.submission,
      })
    },
    buildInitialStateForField(field) {
      if (this.submission.initialState[field.attributes.slug]) {
        return this.submission.initialState[field.attributes.slug]
      }

      return field.attributes.default_value || null
    },
    isFieldVisibleOnlyToMember(field){
      return (this.location === 'profile' || this.location === 'request-access') &&
        (field.attributes.access_level == 'member-visible')
    },
  },
}
</script>
